import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 6px 12px;
  margin-bottom: 20px;

  background-color: ${colors.surfaceContainerHigh};
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.full};

  span.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${colors.primary};
  }

  span.label {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.15em;
    color: ${colors.primary};
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
  margin-bottom: 12px;
`;

export const Subtitle = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 32px;
`;
